import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FileText, Pin } from 'lucide-react';
import { API, BACKEND_URL } from '../config/api';
import { useLanguage } from '../contexts/LanguageContext';
import ShareButtons from '../components/ShareButtons';

const NewsPage = () => {
  const [announcements, setAnnouncements] = useState([]);
  const { t, language } = useLanguage();

  useEffect(() => {
    axios.get(`${API}/announcements`).then(res => setAnnouncements(res.data)).catch(console.error);
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 py-12" data-testid="news-page">
      <div className="text-center mb-12">
        <h1 className="section-title mb-4">{t('newsTitle')}</h1>
        <p className="text-slate-600">{t('newsSubtitle')}</p>
      </div>

      {announcements.length === 0 ? (
        <p className="text-slate-500 text-center py-12">{t('noAnnouncements')}</p>
      ) : (
        <div className="space-y-6">
          {announcements.map(ann => (
            <div key={ann.id} className="card p-6" data-testid={`announcement-${ann.id}`}>
              <div className="flex items-start justify-between mb-3">
                <div>
                  {ann.pinned && (
                    <span className="inline-flex items-center gap-1 text-xs text-[#F97316] font-semibold mb-2">
                      <Pin size={12} /> {t('pinned')}
                    </span>
                  )}
                  <h2 className="font-display font-bold text-xl text-[#1E3A5F]">{ann.title}</h2>
                </div>
                <span className="text-xs text-slate-400 whitespace-nowrap ml-4">
                  {new Date(ann.created_at).toLocaleDateString('el-GR')}
                </span>
              </div>
              <p className="text-slate-600 whitespace-pre-line">{ann.content}</p>
              
              {/* Attachments */}
              {ann.attachments?.length > 0 && (
                <div className="mt-4 space-y-3" data-testid={`attachments-${ann.id}`}>
                  {/* Images inline */}
                  {ann.attachments.filter(a => a.file_type === 'image').length > 0 && (
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mt-3 items-start">
                      {ann.attachments.filter(a => a.file_type === 'image').map(att => (
                        <img key={att.id} src={`${BACKEND_URL}${att.url}`} alt={att.filename} className="w-full h-auto rounded-lg object-contain bg-slate-50" data-testid="news-attachment-image" />
                      ))}
                    </div>
                  )}
                  {/* PDFs / other files as download links */}
                  {ann.attachments.filter(a => a.file_type !== 'image').map(att => (
                    <a key={att.id} href={`${BACKEND_URL}${att.url}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-3 bg-slate-50 rounded-lg hover:bg-slate-100 transition" data-testid={`attachment-${att.id}`}>
                      <FileText size={20} className="text-red-500 flex-shrink-0" />
                      <span className="text-sm font-medium text-[#1E3A5F] truncate">{att.filename}</span>
                      <span className="text-xs text-slate-400 ml-auto">{t('downloadPdf')}</span>
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      <div className="mt-4 flex justify-end">
        <ShareButtons title={language === 'gr' ? 'Νέα WBLA' : 'WBLA News'} />
      </div>
    </div>
  );
};

export default NewsPage;
